/*
 *  Copyright (C) GridGain Systems. All Rights Reserved.
 *  _________        _____ __________________        _____
 *  __  ____/___________(_)______  /__  ____/______ ____(_)_______
 *  _  / __  __  ___/__  / _  __  / _  / __  _  __ `/__  / __  __ \
 *  / /_/ /  _  /    _  /  / /_/ /  / /_/ /  / /_/ / _  /  _  / / /
 *  \____/   /_/     /_/   \_,__/   \____/   \__,_/  /_/   /_/ /_/
 */

import { GmcError } from '@app/core/types';
import { FrontendClusterUser, FrontendClusterUserName, FrontendNewClusterUser } from '@app/core/types/cluster-users';
import { createAction, props } from '@ngrx/store';
import { ClusterId } from '@shared/types/cluster';

export const getClusterUsers = createAction(
  '[Cluster Management] Get cluster users',
  props<{ clusterId: ClusterId }>(),
);
export const clusterUsers = createAction(
  '[Cluster Management] Cluster users',
  props<{ clusterId: ClusterId; users: FrontendClusterUser[] }>(),
);
export const getClusterUsersErr = createAction(
  '[Cluster Management] Get cluster users err',
  props<GmcError & { clusterId: ClusterId }>(),
);

export const addClusterUser = createAction(
  '[Cluster Management] Add cluster user',
  props<{
    clusterId: ClusterId;
    user: FrontendNewClusterUser;
  }>(),
);
export const addClusterUserOk = createAction(
  '[Cluster Management] Add cluster user OK',
  props<{ clusterId: ClusterId; name: FrontendClusterUserName }>(),
);
export const addClusterUserErr = createAction(
  '[Cluster Management] Add cluster user err',
  props<GmcError & { clusterId: ClusterId; name: FrontendClusterUserName }>(),
);

export const removeClusterUser = createAction(
  '[Cluster Management] Remove cluster user',
  props<{ clusterId: ClusterId; name: FrontendClusterUserName }>(),
);
export const removeClusterUserOk = createAction(
  '[Cluster Management] Remove cluster user OK',
  props<{ clusterId: ClusterId; name: FrontendClusterUserName }>(),
);
export const removeClusterUserErr = createAction(
  '[Cluster Management] Remove cluster user err',
  props<GmcError & { clusterId: ClusterId; name: FrontendClusterUserName }>(),
);

export const changeClusterUserPassword = createAction(
  '[Cluster Management] Change cluster user password',
  props<{ clusterId: ClusterId; user: FrontendNewClusterUser }>(),
);
export const changeClusterUserPasswordOk = createAction(
  '[Cluster Management] Change cluster user password OK',
  props<{ clusterId: ClusterId; name: FrontendClusterUserName }>(),
);
export const changeClusterUserPasswordErr = createAction(
  '[Cluster Management] Change cluster user password err',
  props<GmcError & { clusterId: ClusterId; name: FrontendClusterUserName }>(),
);
